/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps } from 'react';

const SvgTravel = (props: SVGProps<SVGSVGElement>) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_travel)" />
    <g transform="translate(9.35, 9.35)" stroke="#F7F5F8" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M24.6115 27.7879L16.5885 13.1212L21.6798 7.97256L26.9269 25.4475L24.6115 27.7879Z" />
      <path d="M19.1731 7.08795L3.84042 2.37262L1.51156 4.73269L14.2109 11.8495" />
      <path d="M22.3455 9.92141L27.5822 4.68441C28.4011 3.8652 29.1043 1.83314 28.2851 1.01483C27.465 0.19533 25.4341 0.897634 24.6152 1.71714L7.88353 18.4484L2.67191 16.8663L0.650006 18.8879L6.68381 22.2256L7.07447 22.6157L10.4121 28.6495L12.4331 26.6279L10.8514 21.4156L16.1566 16.1103" />
      <path d="M4.95779 24.3418L9.69625 19.6033" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_travel" x1="3.5" y1="5.5" x2="45.5" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FDAE41" />
        <stop offset="1" stopColor="#A15E02" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgTravel;
